"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openOnboardingModal = exports.openComposeEditInterstitialModal = exports.dismissModal = void 0;

var _ActionTypes = _interopRequireDefault(require("ComposeUI/redux/ActionTypes"));

var _utils = require("ComposeUI/lib/utils");

var dismissModalCa = (0, _utils.createAction)(_ActionTypes.default.DISMISS_MODAL);
var openComposeEditInterstitialModalCa = (0, _utils.createAction)(_ActionTypes.default.SHOW_COMPOSE_EDIT_INTERSTITIAL_MODAL);
var openOnboardingModalCa = (0, _utils.createAction)(_ActionTypes.default.SHOW_ONBOARDING_MODAL);

var dismissModal = function dismissModal(modalName) {
  return function (dispatch) {
    dispatch(dismissModalCa(modalName));
  };
};

exports.dismissModal = dismissModal;

var openComposeEditInterstitialModal = function openComposeEditInterstitialModal() {
  return function (dispatch) {
    dispatch(openComposeEditInterstitialModalCa());
  };
};

exports.openComposeEditInterstitialModal = openComposeEditInterstitialModal;

var openOnboardingModal = function openOnboardingModal() {
  return function (dispatch) {
    dispatch(openOnboardingModalCa());
  };
};

exports.openOnboardingModal = openOnboardingModal;